var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import ArticleCard from '@domain-group/fe-co-allhomes-article-card';
import { EventBoundary } from '@domain-group/fe-co-allhomes-analytics';
import * as styles from './editorial.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var FeaturedArticle = _ref => {
  var _article$tags, _article$tags$, _article$tags2, _article$tags2$, _article$tags3, _article$tags3$;
  var article = _ref.article;
  return article ? ___EmotionJSX(EventBoundary, {
    name: "featured-article"
  }, ___EmotionJSX(ArticleCard, {
    css: styles.featuredArticleCard,
    article: _objectSpread(_objectSpread({}, article), {}, {
      tags: ((_article$tags = article.tags) === null || _article$tags === void 0 ? void 0 : (_article$tags$ = _article$tags[0]) === null || _article$tags$ === void 0 ? void 0 : _article$tags$.label) && [{
        slug: (_article$tags2 = article.tags) === null || _article$tags2 === void 0 ? void 0 : (_article$tags2$ = _article$tags2[0]) === null || _article$tags2$ === void 0 ? void 0 : _article$tags2$.label.toLowerCase(),
        label: (_article$tags3 = article.tags) === null || _article$tags3 === void 0 ? void 0 : (_article$tags3$ = _article$tags3[0]) === null || _article$tags3$ === void 0 ? void 0 : _article$tags3$.label
      }]
    }),
    imagePosition: "top",
    target: "_blank",
    rel: "noopener"
  })) : null;
};
var fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment FeaturedArticle on Article {\n    title\n    image\n    url\n    tags {\n      label\n    }\n  }\n"])));
FeaturedArticle.fragment = fragment;
export var articlePropTypes = {
  title: PropTypes.string,
  image: PropTypes.string,
  url: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired
  }))
};
FeaturedArticle.propTypes = {
  article: PropTypes.shape(articlePropTypes)
};
FeaturedArticle.defaultProps = {
  article: undefined
};
export default FeaturedArticle;